/**
 * sizing-modals: 尺码页三个弹窗(测量指南 / Sizing Kit 介绍 / 3D 打印指南)的开合。
 * 2026-09-03 尺码对照表弹窗已按品牌要求整体删除,其 open/dialog/close 绑定一并移除。
 * 源自 web-hand-off sizing-modals.js：删 partials:loaded，补 shopify:section:load。
 *
 * [data-open-sizing-guide] → <dialog data-sizing-guide-dialog>
 * [data-open-sizing-kit] → <dialog data-sizing-kit-dialog>(未开卖,纯介绍)
 * [data-open-print3d] → <dialog data-print3d-dialog>(3D 打印指模的打印设置与甩手测试)
 * [data-close-*] / 点背板 / Esc(dialog 原生)关闭。无内容,数据在 HTML。
 *
 * 滚动锁定不在本文件处理:原先这里用 html/body overflow:hidden,但 showModal() 打开的
 * <dialog> 会进 top layer,那套锁对它无效(2026-08-26 线上实测背板仍可滚动)。
 * 现由 assets/yd-scroll-lock.js 在 HTMLDialogElement.prototype.showModal 上统一接管。
 *
 * 幂等,shopify:section:load 后重新初始化。
 */
(function () {
  var PAIRS = [
    { open: '[data-open-sizing-guide]', dialog: '[data-sizing-guide-dialog]', close: '[data-close-sizing-guide]' },
    { open: '[data-open-sizing-kit]', dialog: '[data-sizing-kit-dialog]', close: '[data-close-sizing-kit]' },
    { open: '[data-open-print3d]', dialog: '[data-print3d-dialog]', close: '[data-close-print3d]' },
  ];

  function wire(pair) {
    var dialog = document.querySelector(pair.dialog);
    if (!dialog) return;

    document.querySelectorAll(pair.open).forEach(function (btn) {
      if (btn.dataset.modalReady) return;
      btn.dataset.modalReady = '1';
      btn.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
    });

    if (!dialog.dataset.modalReady) {
      dialog.dataset.modalReady = '1';
      dialog.querySelectorAll(pair.close).forEach(function (btn) {
        btn.addEventListener('click', function () { dialog.close(); });
      });
      // 点背板(dialog 本体,非内部 panel)关闭
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }
  }

  function init() { PAIRS.forEach(wire); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
